const HEX6 = /^#([0-9a-f]{6})$/i;
const HEX3 = /^#([0-9a-f]{3})$/i;
const RGBA =
  /^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)(?:\s*,\s*([\d.]+))?\s*\)$/i;

function expandHex3(hex) {
  const m = hex.match(HEX3);
  if (!m) return hex;
  const h = m[1];
  return `#${h[0]}${h[0]}${h[1]}${h[1]}${h[2]}${h[2]}`.toLowerCase();
}

function hexToRgb(hex) {
  const h = expandHex3(String(hex || '').trim());
  const m6 = h.match(HEX6);
  if (m6) {
    const n = m6[1];
    return {
      r: parseInt(n.slice(0, 2), 16),
      g: parseInt(n.slice(2, 4), 16),
      b: parseInt(n.slice(4, 6), 16),
    };
  }
  return null;
}

export function clampRgbChannel(n) {
  const v = Math.round(Number(n));
  if (Number.isNaN(v)) return 0;
  return Math.max(0, Math.min(255, v));
}

export function hexForPicker(raw, fallback = '#ffffff') {
  const rgb = hexToRgb(raw);
  if (rgb) {
    return `#${[rgb.r, rgb.g, rgb.b]
      .map((v) => v.toString(16).padStart(2, '0'))
      .join('')}`;
  }
  return fallback;
}

export function parseColorToRgb(raw, fallback = '#000000') {
  const s = String(raw || '').trim();
  if (!s) {
    const fb = hexToRgb(fallback) || { r: 0, g: 0, b: 0 };
    return { ...fb, alpha: 1 };
  }

  const rgba = s.match(RGBA);
  if (rgba) {
    return {
      r: clampRgbChannel(rgba[1]),
      g: clampRgbChannel(rgba[2]),
      b: clampRgbChannel(rgba[3]),
      alpha: rgba[4] != null ? Number(rgba[4]) : 1,
    };
  }

  const rgb = hexToRgb(s) || hexToRgb(fallback) || { r: 0, g: 0, b: 0 };
  return { ...rgb, alpha: 1 };
}

export function rgbPartsToCss(r, g, b, alpha = 1) {
  const a = Math.max(0, Math.min(1, Number(alpha) ?? 1));
  if (a < 1) {
    return `rgba(${clampRgbChannel(r)}, ${clampRgbChannel(g)}, ${clampRgbChannel(b)}, ${Math.round(a * 1000) / 1000})`;
  }
  return `rgb(${clampRgbChannel(r)}, ${clampRgbChannel(g)}, ${clampRgbChannel(b)})`;
}

export function rgbPartsToHex(r, g, b) {
  return `#${[r, g, b]
    .map((v) => clampRgbChannel(v).toString(16).padStart(2, '0'))
    .join('')}`;
}
